import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useAuth = () => {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const [userData, setUserData] = useState(null);

	// Check if user is already logged in (from local storage)
	useEffect(() => {
		const storedUser = localStorage.getItem("SellBoostToken");
		const storedUserData = localStorage.getItem("SellBoostUser");
		if (storedUser) {
			setUser(storedUser);
		}
        if(storedUserData){
            setUserData(JSON.parse(storedUserData))
        }
		setLoading(false);
	}, []);
	useEffect(() => {
       
	}, []);

	// Login function (simulated, replace with API call)
	const login = (email, password) => {
		// Replace with actual authentication API request
		const fakeUser = { email, name: "John Doe", token: "fake_jwt_token" };

		localStorage.setItem("user", JSON.stringify(fakeUser));
		setUser(fakeUser);
	};

	// Logout function
	const logout = () => {
		localStorage.removeItem("SellBoostToken");
		navigate("/login");
		toast.success("Logout ");
		setUser(null);
	};

	return {
		user,
		login,
		loading,
		logout,
		isAuthenticated: !!user,
		userData,
		setUserData,
	};
};

export default useAuth;
